import React from 'react';

function ProgressBars({width}) {
    return (
        <div>
            <div
            style={{height:'25px', borderRadius:'4px'}}
            className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: width + "%" }}>{ width + "%" }</div>
            </div>
        </div>
    );
}

export default ProgressBars;